import React,{useEffect, useRef ,useState} from 'react'
import { datazproducts } from "../DarazMall/datazproducts"; 
import ProductInfo from './ProductInfo';
import {useNavigate} from "react-router-dom"
import './saleproduct.css'

function SaleProduct() {
    
    const navigate = useNavigate();
    const [data, setData] = useState(datazproducts);

    const handleClick = (index) => {
        const newData = [...data[index]];
        setData(newData); 
        <ProductInfo item={newData} />
    }
    const Ref = useRef(null);
    // The state for our timer

    const [timer, setTimer] = useState('00:00:00');

    const getTimeRemaining = (e) => {
        const total = Date.parse(e) - Date.parse(new Date());
        const seconds = Math.floor((total / 1000) % 60);
        const minutes = Math.floor((total / 1000 / 60) % 60);
        const hours = Math.floor((total / 1000 / 60 / 60) % 24);
        return {
            total, hours, minutes, seconds
        }
    }

    const startTimer = (e) =>{
        let{total, hours, minutes, seconds} = getTimeRemaining(e);
        if(total >= 0){
            setTimer(
                (hours > 9 ? hours : '0' + hours) +':'+
                (minutes > 9 ? minutes : '0' + minutes) + ':' +
                (seconds > 9 ? seconds : '0' + seconds) 
            )
        }
    }

    const clearTimer = (e) => {
        setTimer('12:00:00');
        if(Ref.current) clearInterval(Ref.current);
        const id = setInterval(() => {
            startTimer(e);
        }, 1000)
        Ref.current = id;
    }

    const getDeadTime = () =>{
        let deadLine = new Date();
        deadLine.setSeconds(deadLine.getSeconds() +43200);
        return deadLine;
    }

    useEffect(() =>{
        clearTimer(getDeadTime());
    })
    


  return (
    <div className='sale-container'>
            
            <div className='sale-one'>
                <h3>On Sale Now</h3>
                <div>
                    <h3>Ending in <span>{timer ==='00:00:00' ? "Time Up" : timer }</span></h3>
                    <p>00:00 Tomorrow</p>
                </div>
            </div>
            <div className='sale-two'>
                {data.map((item,index) => 
                <div className='daraz-info' key={index} onClick={()=>{navigate('/productinfo'); handleClick(index);}}>
                    <img className= "daraz-image"
                        src={item.imageUrl} alt=" "/>  

                    <div className='daraz-detail'>
                        {item.mall ? <div className='daraz-mall'>
                                        <p>mall</p>
                                    </div>   
                                : <div></div> 
                        } 
                        <div className='daraz-title'>
                            <h3>{item.title}</h3>
                        </div>
                        <p className='daraz-price'>{item.price}</p>
                        <p className='daraz-discount'><s>{item.expectedprice}</s> {item.discount}</p>
                        
                        <p className='daraz-rating'>  

                            {Array(item.rating.star).fill(1,(item.rating.star).length, 5).map((i) =>
                                    <p className='star-image'><img src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/99/Star_icon_stylized.svg/1077px-Star_icon_stylized.svg.png" alt ="" /></p>
                                )
                                }
                            <p className='rating-review'>{`(${item.rating.review})`}</p>
                        </p>
                        <button className='addtobasket'>Add to Basket</button>
                    </div>      
                </div>
        )}
        </div>

    </div>
  )
}

export default SaleProduct